import { render, staticRenderFns } from "./NavbarV2.vue?vue&type=template&id=d8a5bd74&scoped=true&lang=pug"
import script from "./NavbarV2.vue?vue&type=script&lang=js"
export * from "./NavbarV2.vue?vue&type=script&lang=js"
import style0 from "./NavbarV2.vue?vue&type=style&index=0&id=d8a5bd74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a5bd74",
  null
  
)

export default component.exports